import React from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const AutobiaLoader = ({ 
  color,
  size = "medium" 
}) => {
  const theme = useTheme();
  
  // Use Autobia primary color as default
  const loaderColor = color || theme.palette.primary.main;
  
  // Size variations
  const sizeMap = {
    small: "30px",
    medium: "45px", 
    large: "60px"
  };
  
  const loaderSize = sizeMap[size] || sizeMap.medium;

  return (
    <Stack alignItems="center" justifyContent="center">
      <div
        className="autobia-loader"
        style={{
          "--loader-color": loaderColor,
          width: loaderSize,
          aspectRatio: "2",
          background: `
            no-repeat radial-gradient(circle closest-side, var(--loader-color) 90%, transparent) 0% 50%,
            no-repeat radial-gradient(circle closest-side, var(--loader-color) 90%, transparent) 50% 50%,
            no-repeat radial-gradient(circle closest-side, var(--loader-color) 90%, transparent) 100% 50%`,
          backgroundSize: "calc(100% / 3) 50%",
          animation: "autobiaLoaderAnimation 1s infinite linear",
        }}
      />

      <style>
        {`
          @keyframes autobiaLoaderAnimation {
            20% { background-position: 0% 0%, 50% 50%, 100% 50%; }
            40% { background-position: 0% 100%, 50% 0%, 100% 50%; }
            60% { background-position: 0% 50%, 50% 100%, 100% 0%; }
            80% { background-position: 0% 50%, 50% 50%, 100% 100%; }
          }
        `}
      </style>
    </Stack>
  );
};

export default AutobiaLoader;